/**
 * 英文语言包
 * 
 * 
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link 
 * @create 2018-03-15 
 */


const translations = {
  //操作
  '提交': 'Submit',
  '下一步': 'Next',
  '返回': 'Back',
  '关闭': 'Close',
  '保存': 'Save',
  '保存并验真': 'Save & Check',
  '确定': 'Ok',
  '上传': 'Upload',
  '取消': 'Cancel',
  '编辑': 'Edit',
  '编辑及验真': 'Edit & Check',
  '报销': 'Reimburse',
  '打印': 'Print',
  '删除': 'Remove',

  '登录': 'Login',
  '获取验证码': 'Get code',
  '获取': 'Get',
  '绑定': 'Bind',
  '选择发票抬头': 'Choose Receipt Title',
  '使用微信抬头': 'Use WeChat Title',

  '查看发票': 'Check the Receipt',
  '查看票据': 'Check the Receipt',
  '下载发票': 'Download Receipt',
  '发到邮箱': 'Send to Email',
  '复制发票链接': 'Copy Receipt Link',
  '放入卡包': 'Put in the package',
  '添加抬头': 'New',
  '添加标签': 'New',
  '更多信息': 'Show More',
  // '新增抬头': 'Create',
  '更多操作': 'More',

  '推荐给朋友': 'Recommend to Friends',
  '设置标签': 'Set tags',
  '清理缓存': 'Clear local storage',


  //提示
  '标签管理小提示': 'Tip: the left slide list can be edited.',
  '提示': 'Warning',
  '删除警告': 'Cannot recover after deletion, confirm to continue?',
  '长按下面文字复制': 'Long press to copy',
  '加载完毕': 'Loaded',
  '加载中': 'Loading',
  '加载失败': 'Load failure',
  '没有任何记录': 'No record',
  '本服务由票易通提供': 'The service is provided by xforceplus, and the hotline :400-630-4000',
  '必填': 'Required',
  '选填': 'Optional',
  '操作成功': 'Success',
  '删除成功': 'Success',
  '修改成功': 'Success',

  '长按识别二维码关注公众号并开票': 'Long press the qrcode to follow wechat public account and receipt',
  '开票成功提示': 'Dear user, your application has been submitted successfully. Please pay attention to the result of the receipt.',
  '抬头上传成功提示': 'Upload successfully, Please wait to invoice',
  '开票注意事项': 'Note:according to article 2 of the state administration of taxation no. 16 of 2017, the contents of the receipt should be issued according to the actual sales situation (only the details are issued).',
  '税号有误': 'Tax ID is wrong',
  '发票抬头长度小于100': 'The receipt title length is less than 100',
  '抬头信息': 'Title infos',
  '订单信息': 'Order infos',
  '请准确填写抬头信息': 'Please fill in the receipt title accurately',
  '请准确填写收件人信息': 'Please fill in the contact info accurately',
  '获取订单信息失败': 'Fail to get order info',
  '表单验证失败提示': 'Error or formatting error in information',


  '发票验真结果法律说明': 'The inspection result of the receipt is not the legal basis, please refer to the local tax authorities.',
  '该发票已通过国税局验真': 'This receipt has been verified by the irs.',

  '该发票未验真': 'This receipt is not verified',
  '该发票验真中': 'The receipt is being checked, please check the result later.',
  '编辑增值税发票友情提示': 'Note:the VAT receipt、Unified sales invoice for motor vehicles only needs to edit the above items, and the other information will be updated automatically after the verification success.',
  '编辑增值税发票保存成功': 'The information is saved successfully, and other relevant information will be updated automatically later, which may take a few minutes.',
  '票据信息保存成功': 'The information is saved successfully',

  // '编辑发票友情提示': '',

  '保存成功': 'Save Success',
  '保存失败': 'Save Failed',
  '提交成功': 'Submitted Successfully',


  '请输入手机号码': 'Please enter your mobile',
  '请输入邮箱': 'Please enter your email',
  '请输入收票邮箱': 'Please enter your email',
  '请输入抬头(必填)': 'Please enter your receipt title(required)',
  '请输入手机号码(必填)': 'Please enter your mobile(required)',
  '请输入收票邮箱(必填)': 'Please enter your email(required)',

  '请选择发票抬头': 'Please select the receipt title',
  '请选择抬头': 'Please select the receipt title',
  '请输入抬头': 'Please enter your receipt title',

  '请输入购销方名称': 'Search..',
  '请输入验证码': 'Please enter the verification code',

  '请输入标签名': 'Please enter the tag name',
  '标签名已存在': 'The tag already exist',
  '标签名称过长': 'The tag length is less than 8',

  '10或12位': '10 or 12 digits or upper case letters',
  '8位': '8 digits',
  '不含税': 'No tax',
  '输入后6位': 'Enter the last 6 digits',


  '请选择票据分类': 'Please select the type',
  '请输入车次': 'Please enter the train No.',
  '请输入航班': 'Please enter the flight No.',
  '请选择始发地': 'Please select the address',
  '请选择到达地': 'Please select the address',
  '请选择出行日期': 'Please select the date',
  '票据说明': 'Note',
  '绑定手机邮箱提示': 'To ensure the security of your electronic receipt, please bind the mobile phone and mail box.',


  '请选择发票日期': 'Please select receipt date',
  '票据影像不存在': 'The receipt image does not exist',
  '已经被处理的票据不允许删除': 'Receipt that have been processed are not allowed to be deleted.',
  '验真成功或验真中的票据不允许编辑': 'It is not allowed to be edited for a true or true check.',


  '手机号绑定成功': 'Mobile phone number binding successfully.',
  '手机号解除绑定成功': 'The phone number is unbound successfully.',
  '验证码已发送,请注意查收': 'The verification code has been sent. Please check.',


  '手机号码未绑定': 'Mobile phone number unbound.',
  '收票邮箱未设置': 'Email unbound',
  '请设置': 'Please set up',
  '未设置': 'Not Set',
  '解除绑定警告': 'After untying, your receipt security will not be guaranteed, determined to continue?',
  '文件提交成功': 'File submission success',
  '增值税发票上传成功': 'The receipt has been put in my wallet, waiting for identification and verification.',
  '微信发票导入成功': 'WeChat receipt imported successfully',
  '下拉刷新': 'Tip:drop-down can refresh the list',
  '增值税发票拍照说明': 'Special VAT receipts, ordinary VAT receipts, VAT electronic receipts,  VAT electronic receipts(tolls), ordinary VAT receipts (volume tickets), etc;',
  '其他票据拍照说明': 'Train tickets, taxi tickets, airline tickets, communication fee receipts, bank receipt vouchers, quota receipts, overseas receipts, etc.',
  '扫发票二维码': 'Scan Qrcode',
  '扫发票二维码说明': 'Scan Qrcode do not support electronic；',
  '正在进行图片预处理': 'Image preprocessing is under way',
  '正在上传文件': 'Uploading files',
  '发票影像列表是空的，无法上传': 'The invoice image list is empty and cannot be uploaded',
  '共上传': '',
  '个发票影像': ' files uploaded',
  '无': 'no data',
  '请输入名称': 'Please enter the name',
  '该终端不支持扫一扫功能': 'Not support',
  '已被他人保存': 'It has been saved by others.',


  //页面名称  栏目标题
  '票税助手': 'xforceplus',
  '订单发票': 'Order Receipt',
  '发票影像': 'Receipt List',
  '拍发票': 'Photo Receipt',
  '票据详情': 'Receipt Detail',
  '标签管理': 'Tags',


  '导入微信发票': 'Import Receipt',
  '共': '',
  '张票据，累计金额': ' bills, ',
  '即将开通，敬请期待': 'To be open, please look forward to it',
  '选取发票失败': 'Choose receipt Failed',
  '取消选取发票': 'Cancellation of Receipt',

  '抬头管理': 'Receipt Title',
  '开户行': 'Bank',
  '发票号码': 'Receipt No.',
  '发票代码': 'Receipt Code',
  '您要添加哪种票据': 'What kind of receipt do you want to add?',
  '拍照技巧': 'Photo Skills',
  '上传发票PDF': 'Upload PDF',
  '上传发票': 'Upload Receipt',
  '确定上传发票': 'Determine the Upload',
  '扫发票二维码': 'Scan Receipt',
  '帮助中心': 'Help Center',
  '个人中心': 'My',
  '关于我们': 'About Us',
  '绑定手机': 'Bind Mobile',
  '绑定邮箱': 'Bind Email',
  '设置收票邮箱': 'Set Mailbox',
  '重新绑定手机': 'Rebind Mobile',
  '解除绑定': 'Unlink',
  '登录票税助手': 'Login xForceplus',
  '验证码': 'Valid Code',

  "订单号": "Order No.",
  '订单金额': 'Order Amount',
  '订单日期': 'Order Date',
  '发票金额': 'Receipt Amount',
  '发票日期': 'Receipt Date',
  '发票详情': 'Receipt Details',
  '编辑发票': 'Edit Receipt',
  '不含税金额': 'Total Amount',
  '税额': 'Total Tax',
  '含税金额': 'Amount with Tax',

  '新增抬头': 'New Receipt Title',
  '新增标签': 'New Tag',
  '新增票据': 'New Receipt',
  '编辑票据': 'Edit Receipt',
  '新增发票': 'New Receipt',
  '上传抬头': 'Upload Receipt',

  '增值税发票': 'VAT',
  '其他票据': 'Other Receipt',

  '抬头类型': 'Type',
  '企业': 'Enterprise',
  '个人或政府机构': 'Personal',
  '发票类型': 'Invoice Type',
  '电子发票': 'Electronic',
  '纸质发票': 'Paper',
  '抬头': 'Title',
  '发票抬头': 'Receipt Title',
  '税号': 'Tax ID',
  '手机号码': 'Mobile',
  '手机号': 'Mobile',
  '邮箱': 'Email',
  '收票邮箱': 'Mailbox',
  '地址': 'Address',
  '电话': 'Tel',
  '电话号码': 'Tel',
  '企业地址': 'Address',
  '开户银行': 'Bank',
  '银行账号': 'Account No.',
  '费用': 'Cost',
  '元': 'Yuan',

  '开具发票': 'Receipt',
  '二维码开票': 'Receipt by Qrcode',
  //   '请输入抬头': '请输入抬头',


  '关注公众号': 'Follow Wechat Public Account',
  '增值税电子普通发票': 'VAT electronic ordinary receipt',
  '销售方': 'Seller',
  '购买方': 'Buyer',

  '编辑抬头': 'Modify Receipt Title',
  '抬头详情': 'Receipt Title',

  '默认抬头': 'Default',
  '默认': 'Default',
  '设为默认': 'Set as Default',

  '报销发票': 'Receipt for Reimbursement',
  '已开发票': 'Receipt',
  '我的票夹': 'Receipt',
  '票夹': 'Receipt Package',
  '发票验真': 'Verify Receipt',
  '发票归集': 'New',

  '分类': 'Type',
  '类型': 'Type',
  '状态': 'Status',
  '日期': 'Date',
  '归集日期': 'Collection Date',

  '校验码': 'Check Code',

  '查看验真结果': 'Verify results',
  '标签': 'Tags',
  '管理标签': 'Manage Tags',
  '商品明细': 'Receipt Details',
  '名称': 'Name',
  '金额': 'Amount',
  '税率': 'Tax Rate',
  '金额/税率': 'Amount/Tax rate',


  '备注': 'Note',
  '发票备注': 'Invoice Note',
  '个人备注': 'Personal Note',
  '始发地': 'From City',
  '到达地': 'To City',
  '从': 'From',
  '到': 'To',
  '上车时间': 'Start Time',
  '下车时间': 'End Time',
  '出行日期': 'Travel Date',
  '车次': 'Train No.',
  '航班': 'Flight No.',
  '票据信息': 'Infomation',


  '服务电话': 'Tel',
  '服务邮箱': 'Email',


  '上拉加载更多': 'Pull up load more',
  '下拉刷新': 'Pull down to refresh',
  '松开加载': 'Release to load',
  '松开刷新': 'Release to refresh',



  //状态
  '已报销': 'Reimbursed',
  '未报销': 'Unreimbursed',

  '待识别': 'Undiscern',
  '识别中': 'Discerning',
  '识别完成': 'Discerned',
  '识别失败': 'Discern Failed',

  '验真成功': 'Verified',
  '验真失败': 'Verify Failed',
  '待验真': 'Unverified',
  '验真中': 'Verifing',
  //物流信息
  '发票邮寄地址': 'Express Address',
  '收件人': 'Contact',
  '联系电话': 'Contact Tel',
  '所在地区': 'District',
  '详细地址': 'Detail Address',
  '电话有误': 'Invalid Tel',
  '请使用微信或支付宝开票': 'Please invoice in Wechat or Alipay',
  '订单异常，无法开票，请联系开票员': 'Fail to invoice, please contact the staff',
  '门店号': 'Storecode',
  '纸质专票': 'Special Invoice',
  '小票已申请开票，请勿重复申请': 'You already apply the invoice',
  '房间号': 'Room Id',
  '姓名': 'UserName',
  '更新日期': 'Update Date',
  '工作流号': 'Work flow',
  '报销金额': 'Reimbursement amount',

  '发票开具成功': 'Invoice Done',
  '该发票已被他人领取': 'The invoice has been received by others',
  '发票开具中': 'Invoice opening',
  '发票申请成功提示': 'The e-invoice will be completed within 24 hours. You will receive the notification after the successful opening.',
  '已被他人开具提示': 'The order has been issued by other people, and can not be repeated.',
  '开票申请提交成功': 'Apply the invoice successfully.',
  '查看开票状态': 'Check the invoice progress',

  '所属集团': 'Group',
  '集团信息': 'Group Info',
  '集团名称': 'Group Name',
  '请输入您所在集团的全称': 'Please input your group name',
  '个人工号': 'Personal NO',
  '请输入您的个人工号': 'Please input your Personal NO',
  '以上信息仅作为公司系统接入时发票抽取凭证': 'The above information is only used as invoice extraction certificate when the company system is connected.',
  '本功能仅限合作商户使用': 'This function is limited to the use of the cooperative merchants',
  '集团绑定成功': 'Bind group successfully',
  '集团名称不能超过200位': 'The length of company name is too long',
  '个人工号不能超过20位': 'The length of personal No is too long',
  '扫码添加的发票无图像，如需保存图像，请选择其他方式': 'There is no image for the invoice added to scan code. If you want to save the image, please choose other ways.',
  '已占用': 'Invoice used',
  '填写2项数据，可完成绑定；清空2项数据，可完成解绑': 'Fill in both of them to bind company or clear both of them to unbind',
  '报销中': 'Reimbursing',

  '已完成': 'finish',
  '开票中': 'invoicing',
  '月份': 'Month',
  '开票状态': 'Invoice status',
  '请填写正确的邮箱': 'Please input your correct email',
  '邮件发送成功': 'Send email successfully',
  '邮件发送失败，请稍后重试': 'Failed to send email, please try again',
  '自动计算': 'auto-calculation',

  '发票申请':'Apply Invoice',
  '发票查询':'Query invoices',
  '请填写小票号':'Please fill in ticket',
  '请填写订单金额':'Please fill in amount',

  'PDF下载链接已复制到粘贴板':'Copy pdf url successfully',
  'PDF下载链接复制到粘贴板失败，请选择邮件发送':'Fail to copy pdf url',

  '个人': 'Person',
  '非企业性单位': 'Non-bussiness',
};

export default translations



// WEBPACK FOOTER //
// ./src/common/i18n/en.js